export default {
      id: "i-money-pie-graphic-usage",
      viewBox: "0 0 21 21",
      url: __webpack_public_path__ + "img/sprite.svg#i-money-pie-graphic",
      toString: function () {
        return this.url;
      }
    }